import { ColDef } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

import { GROUP_CELL_ID } from '@/shared/components/ui/data-table/components/ag-grid-table-core/ag-grid-table-core.constants';
import { GroupNameRenderer } from '@/shared/features/groups/components/group-list/group-name-renderer';
import { useGroupValueGetter } from '@/shared/features/groups/hooks/use-group-value-getter/use-group-value-getter';

const GROUP_COLUMN_MIN_WIDTH = 200;

// List "group" column showing GroupName for the row's groupId. Shared by the
// roles/users lists and the Backoffice tenants list.
export const useGroupColumn = (): ColDef => {
  const { t } = useTranslation();
  const { groupNameValueGetter } = useGroupValueGetter();

  return {
    field: GROUP_CELL_ID,
    headerName: t('groups:group'),
    cellRenderer: GroupNameRenderer,
    minWidth: GROUP_COLUMN_MIN_WIDTH,
    sortable: true,
    valueGetter: groupNameValueGetter,
  };
};
